import { BatteryPlusVariantIcon } from './BatteryPlusVariantIcon';

/**
 * author: Austin Andrews
 * id A4BD7F0D-E95C-413C-B853-435A53854844
 * name battery-plus-variant
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/battery-plus-variant.svg
 * tags
 * - Battery 
 * - Home Automation 
 */
export const BatterySaverIcon = BatteryPlusVariantIcon;
export default BatterySaverIcon